import common from './common.json'
import login from './login.json'
import activeUsers from './ActiveUsers.json'
import activeUsersPreview from './ActiveUsersPreview.json'
import everyone from './Everyone.json'
import everyoneView from './EveryoneView.json'
import exploringView from './ExploringView.json'
import extraView from './ExtraView.json'
import feed from './feed.json'
import home from './Home.json'
import myLoves from './MyLoves.json'
import myStatus from './MyStatus.json'
import privacyPolicy from './PrivacyPolicy.json'
import profile from './Profile.json'
import sevenFacts from './SevenFacts.json'
import spark from './Spark.json'
import status from './status.json'
import userProfile from './UserProfile.json'
import duonamo from './DuoNamo.json'
import adminView from './AdminView.json'
import personals from './personals.json'

export default {
  common,
  login,
  activeUsers,
  activeUsersPreview,
  everyone,
  everyoneView,
  exploringView,
  extraView,
  feed,
  home,
  myLoves,
  myStatus,
  privacyPolicy,
  profile,
  sevenFacts,
  spark,
  status,
  userProfile,
  duonamo,
  adminView,
  personals
}
